var map = {
	"./advertise_ui_no_answer_img_no_1.png": "V4LM",
	"./advertise_ui_no_answer_img_no_2.png": "a0GZ",
	"./advertise_ui_no_answer_img_no_3.png": "s4EM",
	"./advertise_ui_no_answer_img_no_4.png": "jJYK"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "jQFt";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/advertise_ui_no_answer_img_no_.*\.png$
// module id = jQFt
// module chunks = 3